<div class="breadcrumb-container" [class.standalone]="standalone">
  <span *ngFor="let item of items; let last = last" class="breadcrumb-item">
    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
    <a *ngIf="!last" [routerLink]="item.url" class="no-underline">{{ item.title|trans }}</a>
    <span *ngIf="last">{{ item.title|trans }}</span>
    <span *ngIf="!last" class="chevron">></span>
  </span>
</div>
